export default __webpack_public_path__ + "static/media/desert-sunset.e11e847b964ff38949a881951fb1b7fe.jpg";